import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://jfyqyncnzxmbcduwjywh.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpmeXF5bmNuenhtYmNkdXdqeXdoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ1NzQ2NTgsImV4cCI6MjA5MDE1MDY1OH0.0-oYvur-cqw4A3qM6uLZ0l2wBS8ObrAijDwelnVmy1o'

export const supabase = createClient(supabaseUrl, supabaseKey)